<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div (dragover)="projectDragAndDropService.drugOver($event); projectDragAndDropService.clearOpenFolderTimer()" class="tree-view">
    <div class="tree-view__header">
        <div class="tree-view__header-right">
            <div class="tree-view__header-row row ml-0 mr-0">
                <winde-breadcrumbs (changeBreadcrumb)="navigateByFolderId($event)" [breadcrumbs]="activePath()"></winde-breadcrumbs>
            </div>
        </div>
    </div>
    <div class="tree-view__content">
        <winde-tree-list-sidebar>
            <winde-folders-tree></winde-folders-tree>
        </winde-tree-list-sidebar>
        <div class="tree-view__list-content">
            <winde-tree-controls (selectParent)="navigateToParentFolder()" [baseUrl]="baseUrl"
                                 [companyId]="companyId"></winde-tree-controls>
            <div class="tree-view__projects-list">
                <div
                        (dragover)="projectDragAndDropService.drugOver($event)"
                        (drop)="projectDragAndDropService.drop(selectedFolder())"
                        class="tree-view__projects-list__scroll custom-scroll-bar"
                >
                    @if (selectedFolder()?.hasChildren()) {
                        <winde-folders-list [folders]="selectedFolder().children" (openChild)="navigateByFolderId($event)">
                        </winde-folders-list>
                    }
                    <div class="sui-e2e-projects-list-content">
                        @if (selectedFolder()) {
                            <winde-projects-list
                                    [projects]="projects()"
                                    [(sortParam)]="projectSortParam"
                                    [(sortDescending)]="projectSortDescending"
                            >
                            </winde-projects-list>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
